export const getLocalIpAddress = () => {

  return new Promise((resolve, reject) => {
    try{
      window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection; //compatibility for firefox and chrome
      var pc = new RTCPeerConnection({iceServers: []}),
        noop = function() {};
      pc.createDataChannel(""); //create a bogus data channel
      pc.createOffer(pc.setLocalDescription.bind(pc), noop); // create offer and set local description
      pc.onicecandidate = function(ice) { //listen for candidate events
        if (!ice || !ice.candidate || !ice.candidate.candidate)
          return;
        const ip =  /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate);
        if(ip !== null && ip[1] !== undefined){
          resolve(ip[1])
        }
        else{
          reject(new Error("Could not get automatic ip address"));
        }
        pc.onicecandidate = noop;
      };
    }catch(e){
      reject(new Error("Could not get automatic ip address"));
    }
  })
}



// WEBPACK FOOTER //
// ./src/tools/LocalIp.js